export function get (key) {
  const authCache = localStorage.getItem(key);

  if (authCache) {
    return JSON.parse(authCache);
  }
}

export function set (key, data) {
  localStorage.setItem(key, JSON.stringify(data));
}

export function reset (key) {
  localStorage.removeItem(key);
}

// remove all
export function clean () {
  localStorage.clear();
}

export default {
  get,
  set,
  reset,
};